import { render, staticRenderFns } from "./ProjectTeam.vue?vue&type=template&id=1cde8507&"
import script from "./ProjectTeam.vue?vue&type=script&lang=js&"
export * from "./ProjectTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports